module.exports = __webpack_public_path__ + "images/illustrations/illustration-powerpoint@1x-7e6384733f6b8d5c2532335327a68a90.webp";